module.exports = __webpack_public_path__ + "static/media/icon_file_qita.d54ae16b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_qita.svg
// module id = 158
// module chunks = 0